import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUpgradeArrowNewNav = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "#3F4372"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_106_8477)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.13557 13.0396L5.44712 12.3512C5.15561 12.0597 5.15561 11.5883 5.44712 11.2999L11.4727 5.27124C11.7642 4.97973 12.2356 4.97973 12.524 5.27124L18.5526 11.2999C18.8441 11.5914 18.8441 12.0628 18.5526 12.3512L17.8642 13.0396C17.5695 13.3342 17.0889 13.328 16.8005 13.0272L13.2403 9.29034L13.2403 18.2031C13.2403 18.6155 12.9085 18.9473 12.496 18.9473L11.5037 18.9473C11.0912 18.9473 10.7594 18.6155 10.7594 18.2031L10.7594 9.29034L7.19927 13.0272C6.91086 13.3311 6.43018 13.3373 6.13557 13.0396V13.0396Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_106_8477",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 13.8947,
				height: 13.8947,
				fill: "white",
				transform: "translate(18.9473 18.9473) rotate(-180)"
			})
		}) })
	]
});
export default SvgIconUpgradeArrowNewNav;
